import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import { getCurSaleOrderWarehouseProductStore } from '@/api/modules/warehouse-management/warehouseStore';

export const getCurSaleOrderList = data => {
    return axios.request({
        url: 'api/curSaleManagement/order/getCurSaleOrderList',
        data: data,
        method: 'post'
    });
};

export const getCurSaleOrderDetail = data => {
    return axios.request({
        url: 'api/curSaleManagement/order/getCurSaleOrderDetail',
        data: data,
        method: 'post'
    });
};

export const printCurSaleOrderDetail = data => {
    return axios.request({
        url: 'api/curSaleManagement/order/printCurSaleOrderDetail',
        data: data,
        method: 'post'
    });
};

export const getOrderDeliveryHistory = data => {
    return axios.request({
        url: 'api/curSaleManagement/delivery/getOrderDeliveryHistory',
        data: data,
        method: 'post'
    });
};

export const getCurSaleUserUnPaidOrderList = data => {
    return axios.request({
        url: 'api/curSaleManagement/order/getCurSaleUserUnPaidOrderList',
        data: data,
        method: 'post'
    });
};

export const exportCurSaleOrderList = data => {
    return axios.request({
        url: 'api/curSaleManagement/order/exportCurSaleOrderList',
        data: data,
        method: 'post'
    });
};

export const deleteCurSaleOrder = data => {
    return axios.request({
        url: 'api/curSaleManagement/order/deleteCurSaleOrder',
        data: data,
        method: 'post'
    });
};



export const curSaleHelpPaidWithFund = data => {
    return axios.request({
        url: 'api/curSaleManagement/order/curSaleHelpPaidWithFund',
        data: data,
        method: 'post'
    });
};



export const pageInit4CurSaleOrderDelivery = curSaleOrderRecordUuid => {
    return axiosRequest.all([
        getCurSaleOrderDetail({ curSaleOrderRecordUuid }),
        getCurSaleOrderWarehouseProductStore({ curSaleOrderRecordUuid }),
        getOrderDeliveryHistory({ curSaleOrderRecordUuid })
    ]).then(axiosRequest.spread(function (orderDetail, productStore, deliveryHistory) {
        if (orderDetail.code === 0 && productStore.code === 0 && deliveryHistory.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    orderDetail: orderDetail.data.orderDetail,
                    productStore: productStore.data,
                    deliveryHistory: deliveryHistory.data
                }
            };
        }
    }));
};

export const saveCurSaleDelivery = data => {
    return axios.request({
        url: 'api/curSaleManagement/delivery/saveCurSaleDelivery',
        data: data,
        method: 'post'
    });
};
